<template>
  <div class="order-detail-wrapper">
    <div :class="['header-area', $isInWxMP ? 'top-0' : '']">
      <!-- 退款/售后 -->
      <template v-if="orderData.isRefunding">退款申请待客服确认</template>

      <!-- 待支付 -->
      <template v-else-if="orderData.status == 1">
        {{time ? `${time}后订单自动关闭` : '超时未支付，订单已关闭'}}
      </template>

      <!-- 支付成功 待发货/待提货 -->
      <template v-else-if="orderData.status == 2 || orderData.status == 3">
        订单进行中
      </template>

      <!-- 已完成 -->
      <template v-else-if="orderData.status == 5">订单已完成</template>

      <!-- 订单已取消 自动取消/未支付手动取消 退款 -->
      <template v-else-if="orderData.status == 6">
        <template v-if="!orderData.refundStatus">
          <!-- closeType 1-超时未支付 2-退款关闭 4-买家取消 -->
          {{orderData.closeType == 1 ? '超时未支付，订单已关闭' : '订单已取消'}}
        </template>

        <!-- <template v-else-if="orderData.closeType == 5">
          已退款。退款原因：{{orderData.refundDetail.rejectMessage || orderData.refundDetail.buyerDesc || orderData.refundDetail.buyerReason || '处方审核不通过'}}
        </template> -->

        <!-- 常规退款 -->
        <template v-else>订单已完成退款</template>
      </template>

      <!-- 审方驳回退款、开方失败退款 -->
      <!-- <template v-else-if="orderData.status == 10 || orderData.status == 11">
        已退款。退款原因：{{orderData.refundDetail.rejectMessage || orderData.refundDetail.buyerDesc || orderData.refundDetail.buyerReason || '处方审核不通过'}}
      </template> -->
    </div>

    <Description
      :description="serviceDescription"
      v-if="serviceDescription"
    />

    <div class="block order-area">
      <div
        class="goods-list"
        v-if="orderData.orderItemList && orderData.orderItemList.length > 0"
      >
        <Item
          :itemData="item"
          v-for="(item, index) in orderData.orderItemList"
          :key="index"
        />
      </div>

      <div class="other-item flex">
        <div>商品金额</div>
        <div class="price">¥<span>{{orderData.total}}</span></div>
      </div>

      <div class="other-item flex">
        <div>配送金额</div>
        <div>
          <template v-if="orderData.sendFeeType === 'by'">快递包邮</template>
          <template v-if="orderData.sendFeeType === 'df'">邮费到付</template>
          <template v-if="orderData.sendFeeType === 'wxps'">无需配送</template>
        </div>
      </div>

      <div class="other-item flex">
        <div>优惠券</div>
        <div>无</div>
      </div>

      <div class="other-item flex">
        <div>联系方式</div>
        <div>{{orderData.receiverMobile}}</div>
      </div>

      <div class="other-item flex" v-if="orderData.remarks">
        <div>订单备注</div>
        <div>{{orderData.remarks}}</div>
      </div>

      <div class="sub-total">
        <div
          class="count"
          v-if="orderData.totalNum"
        >共 {{orderData.totalNum}} 件</div>

        <div>小计：</div>

        <div class="money">¥<span>{{orderData.total}}</span></div>
      </div>
    </div>

    <div class="block detail-area">
      <div class="other-item flex">
        <div>订单编码</div>
        <div class="flex">
          {{orderData.orderNumber}}<button class="copy-btn" @click="copyFn">复制</button>
        </div>
      </div>

      <div class="other-item flex" v-if="orderData.payType != -1 && orderData.status != 1">
        <div>支付方式</div>
        <div>{{orderData.payTypeStr}}</div>
      </div>

      <div class="other-item flex">
        <div>下单时间</div>
        <div>{{orderData.createTime}}</div>
      </div>

      <div class="contact-btn" @click="contactFn">
        <SvgIcon icon-class="customer_service" class="arrow" />联系客服
      </div>
    </div>

    <div class="footer-area" v-if="btnsList.length > 0">
      <button
        :class="['btn', item.type ? item.type : '']"
        v-for="(item, index) in btnsList"
        :key="index"
        @click="item.handle"
      >{{item.title}}</button>
    </div>

    <!-- 选择原因弹窗 -->
    <!--eslint-disable-next-line vue/no-v-model-argument-->
    <van-dialog v-model:show="reasonVisible" title="确认申请退款并取消本次预约吗?">
      <div class="reason-area">{{
        orderData.serviceData?.serviceStartTime && dayjs(orderData.serviceData.serviceStartTime).isSame(dayjs(), 'day')
        ? '复诊当天申请退款并取消预约，将发起退款申请，申请通过后退款将于1-3个工作日内原路返回'
        : '确认后将自动发起退款，退款将于1-3个工作日内原路返回'
      }}</div>
      <template #footer>
        <div class="dialog-btn-area">
          <button class="dialog-btn cancel" @click="hideReasonFn">取消</button>
          <button class="dialog-btn confirm" @click="refundFn">确定</button>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import {
  defineComponent, onMounted, onUnmounted, reactive, toRefs
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import wx from 'weixin-js-sdk';
import { Toast, Dialog } from 'vant';
import {
  getOrderDetail, getRefundReason, cancelOrder, applyRefund
} from '@/api/order';
import { formatOrderStatus, formatPayType } from '@/common/js/computed';
import { orderStatusMap } from '@/map/index';
import Description from '@/components/service/description.vue';
import Item from '@/components/product/item.vue';
import radioDefaultPath from '@/assets/radio_default.png';
import radioActivePath from '@/assets/radio_active.png';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'orderDetail',
  components: {
    Description,
    Item,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const state = reactive({
      radioDefaultPath,
      radioActivePath,
      orderData: {},
      serviceDescription: '',
      btnsList: [],
      reasonList: [],
      time: '',
      timer: null,
      reasonVisible: false,
      extra: '',
    });

    // 取消订单
    const cancelFn = () => {
      Dialog.alert({
        width: 300,
        title: '提示',
        allowHtml: true,
        className: 'linearGreenClass',
        message: '<span style="color: #666;">是否放弃支付该订单？</span>',
        theme: 'round-button',
        showCancelButton: true,
        closeOnClickOverlay: true,
      }).then(async () => {
        const res = await cancelOrder({ orderNumber: state.orderData.orderNumber, });

        if (res.success) {
          // eslint-disable-next-line no-use-before-define
          getDetail(state.orderData.orderNumber);
        }
      }).catch(() => {
        console.log('cancel');
      });
    };

    // 继续支付
    const payFn = () => {
      const { orderNumber, ihOrderPayVo, } = state.orderData;
      const { payNo, } = ihOrderPayVo;

      const returnUrl = encodeURIComponent(`${window.location.href}&form=ggAppoint`);

      // TODO: 跳转链接，暂时仅对接易健康小程序
      wx.miniProgram.navigateTo({
        url: `/packagesB/cashier/index?orderNumbers=${orderNumber}&payOrderNo=${payNo}&returnUrl=${returnUrl}`,
      });
    };

    // 显示弹窗
    const showReasonFn = () => {
      state.reasonVisible = true;
    };

    // 隐藏弹窗
    const hideReasonFn = () => {
      state.reasonVisible = false;
    };

    // 跳转预约信息
    const toReservationDetail = () => {
      let serviceData = state.orderData.serviceData || {}
      if (state.orderData.bizType >= 12) {
        const url = `/packagesGG/pages/greenPass/index?serviceId=${serviceData.reserveId}`
        wx.miniProgram.navigateTo({
          url,
        });
      } else {
        const url = `/packagesGG/pages/appointInfo/index?id=${serviceData.reserveId}`
        console.log('navigateTo url', url)
        wx.miniProgram.navigateTo({
          url,
        });
      }
    };

    // 售后详情
    const toRefundDetail = () => {
      const { refundsn, } = state.orderData;

      if (refundsn) {
        router.push({
          path: '/refund-detail',
          query: {
            refundSn: refundsn,
          },
        });
      } else {
        Toast('没有售后单号');
      }
    };

    const btnMap = {
      cancelBtn: { title: '取消订单', type: '', handle: cancelFn, },
      payBtn: { title: '继续支付', type: 'orange', handle: payFn, },
      refundBtn: { title: '申请退款', type: '', handle: showReasonFn, },
      reservationDetailBtn: { title: '预约信息', type: '', handle: toReservationDetail, },
      checkRefundBtn: { title: '售后详情', type: '', handle: toRefundDetail, },
    };

    // 获取退款理由
    const getReasonList = async () => {
      const res = await getRefundReason({ refundKey: 'YM_REFUND_REASON_LIST', });
      if (res.success) {
        state.reasonList = res.data;
      }
    };

    // 初始化订单按钮
    const initBtns = (data) => {
      const {
        cancelBtn, payBtn, refundBtn, reservationDetailBtn, checkRefundBtn,
      } = btnMap;

      const { status, showRefundButton, refundStatus, } = data;

      const btnsList = [];

      if (status === orderStatusMap.STAY_PAY) {
        // 待支付
        btnsList.push(cancelBtn);
        btnsList.push(payBtn);
      } else if (status === orderStatusMap.STAY_DELIVER || status === orderStatusMap.STAY_RECEIVE || status === orderStatusMap.SUCCESS) {
        // 待发货/待收货
        // if (showRefundButton) {
        //   btnsList.push(refundBtn);
        //   getReasonList();
        // }
        if (![12,13].includes(state.orderData.bizType)) {
          btnsList.push(refundBtn);
          btnsList.push(reservationDetailBtn);
        } else {
          if (showRefundButton) {
            btnsList.push(refundBtn);
          }
          btnsList.push(reservationDetailBtn);
        }
      } else if (status === orderStatusMap.CLOSE) {
        // 交易关闭，已取消
        // if (refundStatus) {
        //   btnsList.push(checkRefundBtn);
        // }
      }
      state.btnsList = btnsList;
    };

    // 清除定时器
    const clearTimerFn = () => {
      // eslint-disable-next-line no-unused-expressions
      state.timer && clearTimeout(state.timer);
      state.timer = null;
      state.time = '';
    };

    // 倒计时
    const countDown = () => {
      const { createTime, serverCurrentTime, } = state.orderData;
      const limitTime = 20 * 60 * 1000;
      const iCreateTime = new Date(createTime.replace(/-/g, '/')); // IOS兼容

      clearTimerFn();

      let time = parseInt((limitTime - (serverCurrentTime - iCreateTime)) / 1000, 10);

      // 未到30分钟
      if (time > 0) {
        state.timer = setInterval(() => {
          time -= 1;
          const min = parseInt(time / 60, 10);
          const sec = time % 60;

          state.time = `${min}分${sec}秒`;

          // 清除定时器
          if (time <= 0) {
            clearTimerFn();
          }
        }, 1000);
      } else {
        clearTimerFn();
      }
    };

    // 获取订单详情
    const getDetail = async (orderNumber) => {
      const res = await getOrderDetail({ orderNumber, });
      const { success, data, } = res;

      if (success) {
        data.statusStr = data.isRefunding ? '退款申请中' : formatOrderStatus(data);
        data.payTypeStr = data.isFriendPayment === 1 ? '好友代付' : formatPayType(data.payType);

        document.title = data.statusStr;
        state.orderData = data || {};
        state.serviceDescription = data?.serviceData?.serviceDescription || '';
        state.extra = data.extra;
        initBtns(data);

        if (data.status === 1) {
          countDown();
        } else {
          clearTimerFn();
        }
      }
    };

    // 复制订单编号
    const copyFn = () => {
      // 模拟 输入框
      const cInput = document.createElement('input');
      cInput.value = state.orderData.orderNumber || '';
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本框内容

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      Toast('订单编码已复制成功！');

      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput);
    };

    // 联系客服
    const contactFn = () => {
      window.location.href = `tel://${state.orderData.customServicePhone}`;
    };

    // 退款
    const refundFn = async () => {
      const { orderNumber, } = state.orderData;

      const res = await applyRefund({
        orderNumber,
        refundType: 1, // 1整单退款  2拆单退款
        applyType: 1, // 未收到货，售前
        isReceiver: false, // 此处退款默认未收货
        buyerReason: '',
      });

      if (res.success && res.data) {
        Toast('申请成功');
        getDetail(orderNumber);
      }

      hideReasonFn();
    };

    onMounted(() => {
      const { orderNumber, } = route.query;

      getDetail(orderNumber);
    });

    onUnmounted(() => {
      clearTimerFn();
    });

    return {
      ...toRefs(state),
      dayjs,
      copyFn,
      contactFn,
      hideReasonFn,
      refundFn,
    };
  },
});
</script>

<style lang="scss" scoped>
.order-detail-wrapper {
  background-color: $background-color-3;
  padding: 45px 12px 84px;
  padding-bottom: calc(84px + constant(safe-area-inset-bottom));
  padding-bottom: calc(84px + env(safe-area-inset-bottom));
  color: $base-text-color;

  .block {
    background-color: #fff;
    border-radius: $regular-border-radius;
    margin-bottom: 12px;
  }

  .flex {
    @include flex(center, space-between);
  }
}

.header-area {
  @include font(15px, 21px, $base-text-color, center);

  background-color: #fff;
  padding: 0 12px 12px;
  position: fixed;
  left: 0;
  right: 0;
  top: 44px;

  &.top-0 {
    top: 0;
  }
}

.order-area {
  @include font(14px, 20px, $base-text-color);
}

.other-item {
  padding: 6px 16px;

  .price {
    font-size: 12px;

    span {
      font-size: 16px;
    }
  }
}

.sub-total {
  @include flex(baseline, flex-end);
  @include font(13px, 18px, $regular-text-color);

  border-top: 1px solid rgba(227, 227, 227, 0.5);
  padding: 16px 0;
  margin: 10px 16px 0;

  .count {
    margin-right: 14px;
  }

  .money {
    @include font(12px, 21px, $base-text-color);

    span {
      font-size: 18px;
      font-weight: $font-bold;
    }
  }
}

.detail-area {
  @include font(14px, 20px, $regular-text-color);

  padding-top: 12px;

  .copy-btn {
    @include font(12px, 16px, #444);

    background-color: $background-color-3;
    border: 1px solid rgba(151, 151, 151, 0.5);
    border-radius: $secondary-border-radius;
    padding: 2px 8px;
    margin-left: 8px;
  }

  .contact-btn {
    @include flex(center, center);
    @include font(15px, 21px, $base-text-color);

    border-top: 1px solid rgba(227, 227, 227, 0.5);
    padding: 16px 0;
    margin: 14px 16px 0;
  }

  .arrow {
    width: 17px;
    height: 13px;
    margin-right: 4px;
  }
}

.footer-area {
  @include flex(center, flex-end);
  @include fixed-bottom(12px, 16px, 20px, 16px);

  .btn {
    @include font(14px, 18px, $secondary-text-color, center);

    width: 123px;
    border: 1px solid rgba(151, 151, 151, 0.5);
    border-radius: 26px;
    padding: 12px;
    margin-left: 16px;
  }

  .orange {
    background: linear-gradient(149deg, #ff9f05 0%, #fe6602 100%);
    border: none;
    color: #fff;
  }
}

.reason-popup {
  @include font(15px, 21px, $primary-text-color);

  .title-area {
    @include font(17px, 21px, $primary-text-color, center);

    padding: 16px;
    position: relative;

    img {
      display: block;
      width: 22px;
      height: 22px;
      padding: 10px;
      position: absolute;
      right: 4px;
      top: 6px;
    }
  }

  .list-area {
    li {
      @include flex(center, space-between);

      padding: 8px 16px;

      img {
        display: block;
        width: 20px;
        height: 20px;

        &.unselect {
          opacity: 0.7;
        }
      }
    }

    .textarea {
      @include font(13px, 18px, $primary-text-color);

      width: calc(100% - 32px);
      height: 64px;
      border: 1px solid #ececec;
      border-radius: $regular-border-radius;
      padding: 8px;
      margin: 4px 16px;
      box-sizing: border-box;
    }
  }

  .btn-area {
    padding: 20px 16px;
  }

  .submit-btn {
    @include font(17px, 24px, #fff, center);

    width: 100%;
    background: linear-gradient(149deg, #ff9f05 0%, #fe6602 100%);
    border-radius: 28px;
    padding: 13px;
  }
}

.reason-area {
  padding: 0 22px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}

.dialog-btn-area {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 21px;
}

.dialog-btn {
  height: 40px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;

  &.cancel {
    color: #12ad70;
    background: #e8f9f2;
  }

  &.confirm {
    color: #fff;
    background: #14c780;
  }
}
</style>
